var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"results"},[_c('img',{staticClass:"results-img",attrs:{"src":require("@/assets/images/icon_result.png")}}),_c('div',{staticClass:"results-tit"},[_vm._t("title")],2),_c('div',{staticClass:"results-label"},[_vm._t("label")],2),_c('div',{staticClass:"result-other"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }